export default __webpack_public_path__ + "static/media/logo-bottom.637e7ec0.png";